export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_ERROR = 'LOGOUT_ERROR';
export const SIGNIN_SUCCESS = 'SIGNIN_SUCCESS';
export const REMOVE_ERROR = 'REMOVE_ERROR';

export const RETRIEVE_SUBSCRIPTION_START = 'RETRIEVE_SUBSCRIPTION_START';
export const RETRIEVE_SUBSCRIPTION_SUCCESS = 'RETRIEVE_SUBSCRIPTION_SUCCESS';
export const RETRIEVE_SUBSCRIPTION_FAIL = 'RETRIEVE_SUBSCRIPTION_FAIL';

export const ERROR = 'ERROR';


// WEBPACK FOOTER //
// ./src/components/Auth/authActionTypes.js